import React, { useState } from 'react';
import { api } from '../lib/api';
import type { RequestPriority } from '../types';
import { Modal, Alert, inputClass, labelClass, primaryBtn, secondaryBtn } from './ui';

export const PRIORITIES: RequestPriority[] = ['low', 'medium', 'high'];

export default function RequestFormModal({
  open,
  onClose,
  onSubmitted,
}: {
  open: boolean;
  onClose: () => void;
  onSubmitted: () => void;
}) {
  const [form, setForm] = useState({ title: '', description: '', priority: 'medium' as RequestPriority, due_date: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await api.post('/requests', { ...form, due_date: form.due_date || null });
      onSubmitted();
      onClose();
      setForm({ title: '', description: '', priority: 'medium', due_date: '' });
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} title="New Request">
      {error && <Alert>{error}</Alert>}
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className={labelClass}>Request Title *</label>
          <input
            className={inputClass}
            required
            value={form.title}
            onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))}
            placeholder="e.g. Replace damaged gate motor"
          />
        </div>
        <div>
          <label className={labelClass}>Priority</label>
          <select
            className={inputClass}
            value={form.priority}
            onChange={(e) => setForm((f) => ({ ...f, priority: e.target.value as RequestPriority }))}
          >
            {PRIORITIES.map((p) => (
              <option key={p} value={p}>{p.charAt(0).toUpperCase() + p.slice(1)}</option>
            ))}
          </select>
        </div>
        <div>
          <label className={labelClass}>Due Date</label>
          <input
            type="date"
            className={inputClass}
            value={form.due_date}
            onChange={(e) => setForm((f) => ({ ...f, due_date: e.target.value }))}
          />
        </div>
        <div>
          <label className={labelClass}>Description</label>
          <textarea
            className={inputClass}
            rows={5}
            value={form.description}
            onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))}
            placeholder="What do you need? Include any relevant details..."
          />
        </div>
        <div className="flex justify-end space-x-3">
          <button type="button" onClick={onClose} className={secondaryBtn}>Cancel</button>
          <button type="submit" disabled={saving} className={primaryBtn}>{saving ? 'Submitting...' : 'Submit Request'}</button>
        </div>
      </form>
    </Modal>
  );
}
